<template lang="html">
	<div id="page__tracking-statuses" class="center-panel">
		<md-content md-theme="white" v-bind:loading="progress">
			<stock-menu></stock-menu>
			<sort-table
				v-bind:columns="tableColumns" v-model="tableStatuses" v-on:refresh="getStatuses" v-bind:per-page="perPage"
				v-bind:total="statusesAmount" ref="table" table-id="tracking-statuses"
				tableHeight="calc(100% - 48px)" v-bind:showAddButton="false" link
			>
				<template slot="name" slot-scope="scope">
					<span v-bind:style="'color: ' + scope.item.color"> {{scope.item.name}} </span>
				</template>
				<template slot="code" slot-scope="scope">
					<span> {{(scope.item.code) ? scope.item.code : 'Не установлен'}} </span>
				</template>
				<template slot="tracking_type" slot-scope="scope">
					<span> {{scope.item.tracking_type}} </span>
				</template>
				<template slot="confirm_deal" slot-scope="scope">
					<span> {{(scope.item.confirm_deal && parseInt(scope.item.confirm_deal) === 1) ? 'Да' : 'Нет'}} </span>
				</template>
				<template slot="actions" slot-scope="scope">
					<!--
					// Удаление закомментированно т.к. у пользователей не должно быть возможности добавлять и удалять статусы
                    <z-icon-button v-bind:icon="['fa', 'trash']" danger-light  rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
					-->
                </template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import StockMenu from './menu';
	import SortTable from "@/components/SortTable";
	import SimpleColorPicker from '@/components/SimpleColorPicker';
	import ZIconButton from '@/components/ZIconButton';
	export default {
		components: {
			SortTable, StockMenu, SimpleColorPicker, ZIconButton
		},
		data() {
			return {
				tableStatuses: [],
				tableColumns: [
					{ label: 'ID', field: 'id', default: true, sortable: true },
					{ label: 'Название', field: 'name', sortable: true },
					{ label: 'Код', field: 'code'},
					{ label: 'Тип', field: 'tracking_type'},
					{ label: 'Описание', field: 'description'},
					{ label: 'Потдверждение заявки', field: 'confirm_deal'},
					{ label: '', field: 'actions' },
				],
				currentPage: 1,
				perPage: 50,
				trackingTypes: [
					{label: 'Принят у отправителя (влияет на приём)', value: 1},
					{label: 'Промежуточный (влияет на приём)', value: 2},
					{label: 'Промежуточный (влияет на выдачу)', value: 3},
					{label: 'Промежуточный (не влияет на приём и выдачу)', value: 4},
					{label: 'Прибыл в пункт выдачи (влияет на приём)', value: 5},
					{label: 'Выдан получателю (влияет на выдачу)', value: 6},
				]
			}
		},
		created() {
			this.$store.commit('setTitle', 'Статусы')
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-tracking-statuses'];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список статусов
			 */
			statuses() {
				return !this.$store.state.stock.freight_statuses ? [] : this.$store.state.stock.freight_statuses.map(status => {
					status.routerLink = { name: 'TrackingStatus', params: { id: status.id }, query: this.$route.query };
					return status;
				});
			},
			/**
			 * Количество статусов
			 */
			statusesAmount() {
				return this.$store.state.stock.freight_statuses_amount
			}
		},
		watch: {
			'statuses'() {
				this.prepareStatuses();
			},
			'trackingTypes'() {
				this.prepareStatuses();
			},
		},
		methods: {
			/**
			 * Подготовка статуса
			 */
			prepareStatuses() {
				if (!this.statuses || !this.trackingTypes) return [];
				this.tableStatuses = Object.assign([], this.statuses);
				this.tableStatuses = this.tableStatuses.map(status => {
					let typeLabel = this.trackingTypes.find(item => (item.value == status.tracking_type));
					if (typeLabel) status.tracking_type = typeLabel.label;
					return status;
				});
			},
			/**
			 * Получение статуса
			 */
			getStatuses(page, count, orderBy, orderType) {
				this.$store.commit('showProgressBar', 'get-tracking-statuses');
				return this.$store.dispatch('stock/getTrackingStatuses', {
					page: page,
					order_by: orderBy,
					order_type: orderType,
					count: count
				})
				.then(() => this.prepareStatuses())
				.finally(() => this.$store.commit('hideProgressBar', 'get-tracking-statuses'));
			},
			/**
			 * Добавление статуса
			 */
			addStatus() {
				this.$router.push({ name: 'TrackingStatus', params: { id: 'new' } });
			},
			/**
             * Удаление группы клиентов
             */
            removeStatus(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-tracking-statuses');
                this.$store.dispatch('stock/deleteTrackingStatus', id)
                    .then(() => this.$root.$emit('refresh-table', 'tracking-statuses'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-tracking-statuses'));
            },
            /**
             * Модальное окно с подтверждением удаления группы
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении группы', 'Действие необратимо!',
                    () => this.removeStatus(id)
                );
            }
		}
	}
</script>
<style lang="sass"></style>


// WEBPACK FOOTER //
// TrackingStatuses.vue?4f03bc88